import { useEffect, useState } from "react";
import { API } from "./api";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  TextField,
  Button
} from "@mui/material";
import Dashboard from "./Dashboard"; // ✅ IMPORTANT

export default function Developers() {
  const [apps, setApps] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedDeveloper, setSelectedDeveloper] = useState(null);

  useEffect(() => {
    API.get("/apps").then(res => {
      const data = res.data.data || res.data || [];
      setApps(data);
    });
  }, []);

  // ✅ 🔥 SHOW DASHBOARD WITH FILTER
  if (selectedDeveloper) {
    return (
      <>
        <Button
          variant="contained"
          style={{ marginBottom: "20px" }}
          onClick={() => setSelectedDeveloper(null)}
        >
          ⬅ Back
        </Button>

        {/* ✅ PASS FILTER TO DASHBOARD */}
        <Dashboard filterDeveloper={selectedDeveloper} />
      </>
    );
  }

  // 🔹 EXISTING LOGIC (UNCHANGED)
  const developerMap = {};

  apps.forEach(app => {
    if (!app.developer) return;

    const devList = app.developer.split(/[\/,]/);

    devList.forEach(devRaw => {
      let dev = devRaw.trim();
      if (!dev) return;

      let name = dev;
      let email = "";

      if (dev.includes("@")) {
        const parts = dev.split(" ");
        email = parts.find(p => p.includes("@")) || "";
        name = parts.filter(p => !p.includes("@")).join(" ");
      }

      name = name.trim();

      if (name) {
        name = name.charAt(0).toUpperCase() + name.slice(1);
      }

      const key = name + "|" + email;

      if (!developerMap[key]) {
        developerMap[key] = {
          name,
          email,
          count: 0
        };
      }

      developerMap[key].count += 1;
    });
  });

  let developers = Object.values(developerMap);

  // 🔹 Search filter
  if (search) {
    developers = developers.filter(d =>
      d.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  return (
    <>
      <TextField
        fullWidth
        placeholder="Search Developer..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: "20px" }}
      />

      <Grid container spacing={3}>
        {developers.map((dev, index) => {
          const initial = dev.name ? dev.name.charAt(0).toUpperCase() : "?";

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                onClick={() => setSelectedDeveloper(dev.name)} // ✅ CLICK
                style={{
                  cursor: "pointer",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #6366f1, #1e293b)",
                  color: "white"
                }}
              >
                <CardContent style={{ textAlign: "center" }}>
                  <Avatar
                    style={{
                      margin: "0 auto",
                      backgroundColor: "#22c55e",
                      width: 50,
                      height: 50
                    }}
                  >
                    {initial}
                  </Avatar>

                  <Typography variant="h6" style={{ marginTop: "10px" }}>
                    {dev.name}
                  </Typography>

                  <Typography variant="body2">
                    {dev.email || "No Email"}
                  </Typography>

                  <Typography variant="body2" style={{ marginTop: "5px" }}>
                    {dev.count} apps
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
